import { ControlledTable } from "Components";
import FilterData from "Components/Filter2/Data";
import { Filter2DataProps } from "DataTypes/Common";
import { SingleFormObjType } from "DataTypes/Form";
import { PreApprovedPlanListType } from "DataTypes/PatientManagement.type";
import { actionArrType, columnType } from "DataTypes/Table";

export const FormDataObj: SingleFormObjType = {
  id: "practice",
  placeholder: "Select Problem",
  boxType: "single-select",
  boxSize: 3,
  validatetype: "dropdown",
  readOnly: false,
};

export const TableCol: () => columnType[] = () => {
  const Arr: columnType[] = [
    ControlledTable.ColumnData.ProblemNameCol("30%"),
    ControlledTable.ColumnData.VersionCol("15%"),
    ControlledTable.ColumnData.CreatedAtCol("20%"),
    ControlledTable.ColumnData.StatusCol("15%"),
    ControlledTable.ColumnData.ActionCol("25%"),
  ];
  return Arr;
};

export const actionArr: (
  handleView: () => void,
  handleEdit: () => void,
  handleDelete: () => void,
  handleEnableDisable: () => void,
  data: PreApprovedPlanListType
) => actionArrType[] = (
  handleView,
  handleEdit,
  handleDelete,
  handleEnableDisable,
  data
) => {
  const status = data.status?.toUpperCase();
  const Arr: actionArrType[] = [
    ...(status != "DISABLED"
      ? [ControlledTable.ActionData.editAction({ handleClick: handleEdit })]
      : []),
    ...status == "DRAFT" ? [
      ControlledTable.ActionData.deleteAction(handleDelete)
    ] : [
      ControlledTable.ActionData.ViewCarePlanAction(
        handleView,
        "View Pre-Approved Plan"
      ),
      ControlledTable.ActionData.enableDisableAction(
        handleEnableDisable,
        status == "APPROVED",
        status == "DISABLED" || data.isDisabled || data.isAdminDisabled
      ),
    ],

  ];
  return Arr;
};

export const FilterArr: () => Filter2DataProps[] = () => {
  const Arr: Filter2DataProps[] = [
    FilterData.problemName,
    FilterData.papVersion,
    FilterData.createdAtFrom,
    FilterData.createdAtTo,
    FilterData.status,
  ];
  return Arr;
};
